import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { Link } from "react-router-dom";
import styled from "styled-components";
import logo from "Images/fixo_ko2.png";
import { Color } from "Styles/Theme";
import { device } from "Styles/Media";
const EditForm = () => {
  const [arrowdown, setArrowdown] = useState(false);
  const [inputCompany, setInputCompany] = useState("");
  const [inputJobPosition, setInputJobPosition] = useState("");
  const [nextButton, setNextButton] = useState(false);
  const history = useHistory();
  const [companyValue, setCompanyValue] = useState("");
  const [jobPositionValue, setJobPositionValue] = useState("");
  const company = (e) => {
    setInputCompany(e.target.value.length);
    setCompanyValue(e.target.value);
  };
  const jobPosition = (e) => {
    setInputJobPosition(e.target.value.length);
    setJobPositionValue(e.target.value);
  };
  const clickNextButton = () => {
    setNextButton(true);
    history.push("/edituser");
    sessionStorage.setItem("company", companyValue);
    sessionStorage.setItem("jobPosition", jobPositionValue);
  };
  const arrowdownShow = useCallback(() => {
    if (inputJobPosition > 0 && inputCompany > 0) {
      setArrowdown(true);
    } else {
      setArrowdown(false);
    }
  }, [inputCompany, inputJobPosition]);
  useEffect(() => {
    arrowdownShow();
    // eslint-disable-next-line
  }, [inputCompany, inputJobPosition]);
  return (
    <Container fade={nextButton}>
      <Link to="/">
        <Logo src={logo} alt="Fixo" />
      </Link>
      <EditFormWrap arrow={arrowdown}>
        <span>지원 회사와 직무를 알려주세요</span>
        <p>
          어느 회사, 어떤 직무로 지원하시나요? <br />그 회사 선배의 도움으로
          자소서를 완성하세요
        </p>
        <EditTextBox>
          <span>지원회사</span>
          <input
            onChange={company}
            type="textBox"
            name="company"
            placeholder="ex ) 삼성전자"
            className="first_input"
          ></input>
        </EditTextBox>
        <EditTextBox>
          <span>지원직무</span>
          <input
            onChange={jobPosition}
            type="textBox"
            name="jobPosition"
            placeholder="ex ) 마케팅"
          ></input>
        </EditTextBox>
      </EditFormWrap>
      <ArrowShow arrow={arrowdown} onClick={clickNextButton}>
        <IoIosArrowDown className="arrowDowns" />
      </ArrowShow>
    </Container>
  );
};
export default EditForm;
const Container = styled.div`
  position: relative;
  max-width: 1200px;
  height: 100vh;
  margin: 0 auto;
  animation: ${(props) => (props.fade ? "fadeUp" : "")};
  animation-duration: 0.4s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  @keyframes fadeUp {
    0% {
      bottom: 0;
      opacity: 1;
    }
    100% {
      bottom: 100vh;
      opacity: 0;
    }
  }
`;
const Logo = styled.img`
  width: 92px;
  margin-top: 27px;
  margin-left: 25px;
`;
const EditFormWrap = styled.div`
  width: 460px;
  animation: ${(props) => (props.arrow ? "boxUp" : "boxDown")};
  animation-duration: 0.5s;
  animation-iteration-count: 1;
  animation-fill-mode: both;
  position: absolute;
  top: 50%;
  left: 50%;
  @media ${device.mobile} {
    width: 320px;
  }
  span {
    font-family: Cafe24Ohsquare;
    font-size: 36px;
    color: #7a04d4;
    display: inline-block;
    @media ${device.tablet} {
      display: inline-block;
      width: 100%;
    }
    @media ${device.mobile} {
      width: 100%;
    }
  }
  text-align: center;
  @keyframes boxUp {
    0% {
      transform: translate(-50%, -50%);
    }
    100% {
      transform: translate(-50%, -60%);
    }
  }
  @keyframes boxDown {
    0% {
      transform: translate(-50%, -60%);
    }
    100% {
      transform: translate(-50%, -50%);
    }
  }
  p {
    padding: 20px 0 45px;
    color: #515151;
    font-size: 21px;
    line-height: 32px;
    @media ${device.tablet} {
      font-size: 19px;
      line-height: 28px;
    }
    @media ${device.mobile} {
      font-size: 17px;
      line-height: 25px;
    }
  }
`;
const EditTextBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 300px;
  margin: 0 auto;
  @media ${device.mobile} {
    width: 240px;
  }
  img {
    height: 22px;
    margin-bottom: 15px;
  }
  span {
    margin-bottom: 13px;
    font-size: 22px;
    color: #404040;
  }
  input {
    width: 300px;
    height: 55px;
    padding: 10px 20px;
    border: 1px solid #b3b3b3;
    border-radius: 10px;
    font-size: 17px;
    color: #515151;
    &:focus {
      outline: none;
      border: 1px solid #7903d4;
      box-shadow: 3px 4px 9px #b7b7b7;
    }
    @media ${device.mobile} {
      width: 240px;
    }
  }
  input::placeholder {
    color: #b3b3b3;
  }
  .first_input {
    margin-bottom: 40px;
    @media ${device.mobile} {
      margin-bottom: 20px;
    }
  }
`;
const ArrowShow = styled.div`
  .arrowDowns {
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 60px;
    color: ${Color.purple};
    animation: down ease-in;
    animation-duration: 0.8s;
    animation-iteration-count: infinite;
    cursor: pointer;
  }
  @keyframes down {
    0% {
      bottom: 50px;
    }
    70% {
      bottom: 70px;
    }
    100% {
      bottom: 50px;
    }
  }
  display: ${(props) => (props.arrow ? "block" : "none")};
`;
